import React from 'react'
import VirtualCardsNeedsApproval from 'src/app/VirtualCardsNeedsApproval/VirtualCardsNeedsApproval'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { virtualCardsRequestsRouteProps } from 'src/navigation/routeProps'

const VirtualCardsRequestsAppRoute: AppRoute = {
  routeProps: virtualCardsRequestsRouteProps,
  component: <VirtualCardsNeedsApproval />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default VirtualCardsRequestsAppRoute
